import { Values } from '../utils/types';

export const ARTICLE_UNIT_TYPES = {
  /** Ha or ac */
  AREA: 'area',
  /** Hours (decimal) */
  TIME: 'time',
  /** Km or miles */
  DISTANCE: 'distance',
  UNIT: 'unit',
  PACKAGE: 'package',
  /** Tons */
  MASS: 'mass',
  /** Liters */
  VOLUME: 'volume',
  OTHER: 'other',
} as const;
export type ArticleUnitType = Values<typeof ARTICLE_UNIT_TYPES>;

export const ARTICLE_STATUS = {
  AVAILABLE: 'available',
  ARCHIVED: 'archived',
} as const;
export type ArticleStatus = Values<typeof ARTICLE_STATUS>;

export const PHYTO_VIRTUAL_ARTICLE_ID = 'default_phyto_article';
